import { Component, OnInit, ViewChild } from '@angular/core';
import { SystemService } from '../../../service/system.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Globals } from 'src/app/globals';
declare var $: any;

@Component({
  selector: 'app-system-parameters',
  templateUrl: './system-parameters.component.html',
  styleUrls: ['./system-parameters.component.scss']
})
export class SystemParametersComponent implements OnInit {

  showLoader: boolean = false;
  systemParamData: any;
  currentSysParam: any;
  currentSysParamIndex: any;

  @ViewChild('closeEdit') private closeEdit: any;

  updateSysParam = new FormGroup({
    parameterValue: new FormControl('', [
      Validators.required,
    ])
  });

  constructor(public globals: Globals, private systemService: SystemService, private toastrService: ToastrService, public translate: TranslateService) { }

  ngOnInit(): void {
    this.getAllSystemParameters();
  }

  getAllSystemParameters() {
    this.showLoader = true;
    this.systemService.getSystemParameters().subscribe(
      data => {
        this.systemParamData = data
      },
      error => {
        this.updateTable();
        this.toastrService.error("can't get system parameters");
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
        this.updateTable();
      }
    );
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [3] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        searching: false,
        // search: {
        //   searchPlaceholder: "Search",
        // },
        paging: true,
        // language: {
        //   search: "",
        //   searchPlaceholder: "Search",
        // },
        // buttons: [
        //   'excel', 'pdf'
        // ]
        buttons: [{
          extend: 'csvHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'CSV'
        },
        {
          extend: 'pdfHtml5',
          text: '<span style="font-size: 3em; color: #e04006;"><i class="fas fa-file-pdf fa-sm"></i></span>',
          titleAttr: 'PDF'
        }]
      });
    }, 1);

  }

  getCurrentSysParam(index: number) {
    if (typeof this.systemParamData[index] != 'undefined') {
      this.currentSysParamIndex = index;
      let moduleParam = this.systemParamData[index];
      this.currentSysParam = moduleParam;
      this.updateSysParam.controls.parameterValue.setValue(moduleParam.parameterValue);
    } else {
      this.currentSysParamIndex = null;
      this.currentSysParam = null;
      this.toastrService.warning(this.translate.instant('NOT_FOUND'));
    }
  }

  updateSysParamSubmit() {
    if (this.updateSysParam.valid) {
      let parameterValue = this.systemParamData[this.currentSysParamIndex].parameterValue = this.updateSysParam.controls.parameterValue.value;
      // console.log(this.currentSysParam);
      let id = this.currentSysParam.id;
      let parameterCode = this.currentSysParam.parameterCode;
      this.systemService.updateSysParameter(id, parameterCode, parameterValue)
        .subscribe(
          data => {
            this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
            this.closeEdit.nativeElement.click();
            this.updateSysParam.reset();
            // window.location.reload();
          },
          error => {
            this.toastrService.warning(this.translate.instant('CAN_NOT_UPDATE'));
          }
        );
    } else {
      this.toastrService.warning(this.translate.instant('PLEASE_ENTER_REQUIRE_FIEDLS'));
      this.updateSysParam.markAllAsTouched();
      this.updateSysParam.markAsDirty();
    }
  }
}
